export const FETCH_CALENDAR_EVENTS_REQUEST = "FETCH_CALENDAR_EVENTS_REQUEST";
export const FETCH_CALENDAR_EVENTS_SUCCESS = "FETCH_CALENDAR_EVENTS_SUCCESS";
export const FETCH_CALENDAR_EVENTS_FAILURE = "FETCH_CALENDAR_EVENTS_FAILURE";


export const FETCH_EVENT_CATEGORIES_REQUEST = "FETCH_EVENT_CATEGORIES_REQUEST";
export const FETCH_EVENT_CATEGORIES_SUCCESS = "FETCH_EVENT_CATEGORIES_SUCCESS";
export const FETCH_EVENT_CATEGORIES_FAILURE = "FETCH_EVENT_CATEGORIES_FAILURE";
